import OrderSagaTracePanel from './components/OrderSagaTracePanel.vue';

export default function registerAdminVueComponents(app) {
    app.component('order-saga-trace-panel', OrderSagaTracePanel);
}
